import React from "react";
import stringUtils from "../_services/string-utils";

export const MonthOptions = () => {
    return (
        <>
            <option value="">Monat</option>
            <option value="1">Januar</option>
            <option value="2">Februar</option>
            <option value="3">März</option>
            <option value="4">April</option>
            <option value="5">Mai</option>
            <option value="6">Juni</option>
            <option value="7">Juli</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">Oktober</option>
            <option value="11">November</option>
            <option value="12">Dezember</option>
        </>
    );
};

export const SKROptions = () => {
    return (
        <>
            <option value="">Nicht bekannt</option>
            <option value="SKR_03">SKR 03</option>
            <option value="SKR_04">SKR 04</option>
            <option value="SKR_07">SKR 07</option>
            <option value="SAP">SAP</option>
        </>
    );
};

export const NonSAPSKROptions = () => {
    return (
        <>
            <option value="">Nicht bekannt</option>
            <option value="SKR_03">SKR 03</option>
            <option value="SKR_04">SKR 04</option>
            <option value="SKR_07">SKR 07</option>
        </>
    );
};

export const AccountNumberLengthOptions = () => {
    return (
        <>
            <option value="">Nicht bekannt</option>
            <option value="4">4 (Standard)</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
        </>
    );
};

export const AdditionalInformationOptions = ({ rule, existingAdditionalInformationRules }) => {
    return (
        <>
            {rule && existingAdditionalInformationRules && existingAdditionalInformationRules.length > 0 ? (
                <>
                    {ADDITIONAL_INFORMATION_OPTIONS.map((availableRule, index) => {
                        return (
                            (stringUtils.equals(rule.index, availableRule.enumIdentifier) ||
                                !additionalInformationAlreadyUsed(
                                    existingAdditionalInformationRules,
                                    availableRule.enumIdentifier
                                )) && (
                                <option key={index} value={availableRule.enumIdentifier}>
                                    {availableRule.enumDescription}
                                </option>
                            )
                        );
                    })}
                </>
            ) : (
                <>
                    {ADDITIONAL_INFORMATION_OPTIONS.map((availableRule, index) => {
                        return (
                            <option key={index} value={availableRule.enumIdentifier}>
                                {availableRule.enumDescription}
                            </option>
                        );
                    })}
                </>
            )}
        </>
    );
};

const additionalInformationAlreadyUsed = (existingAdditionalInformationRules, value) => {
    return existingAdditionalInformationRules
        .map((additionalInformationRule) => additionalInformationRule.index)
        .includes(value);
};

export const ADDITIONAL_INFORMATION_OPTIONS = [
    { enumIdentifier: "ZUSATZINFORMATION_1", enumDescription: "Zusatzinformation 1" },
    { enumIdentifier: "ZUSATZINFORMATION_2", enumDescription: "Zusatzinformation 2" },
    { enumIdentifier: "ZUSATZINFORMATION_3", enumDescription: "Zusatzinformation 3" },
    { enumIdentifier: "ZUSATZINFORMATION_4", enumDescription: "Zusatzinformation 4" },
    { enumIdentifier: "ZUSATZINFORMATION_5", enumDescription: "Zusatzinformation 5" },
    { enumIdentifier: "ZUSATZINFORMATION_6", enumDescription: "Zusatzinformation 6" },
    { enumIdentifier: "ZUSATZINFORMATION_7", enumDescription: "Zusatzinformation 7" },
    { enumIdentifier: "ZUSATZINFORMATION_8", enumDescription: "Zusatzinformation 8" },
    { enumIdentifier: "ZUSATZINFORMATION_9", enumDescription: "Zusatzinformation 9" },
    { enumIdentifier: "ZUSATZINFORMATION_10", enumDescription: "Zusatzinformation 10" },
    { enumIdentifier: "ZUSATZINFORMATION_11", enumDescription: "Zusatzinformation 11" },
    { enumIdentifier: "ZUSATZINFORMATION_12", enumDescription: "Zusatzinformation 12" },
    { enumIdentifier: "ZUSATZINFORMATION_13", enumDescription: "Zusatzinformation 13" },
    { enumIdentifier: "ZUSATZINFORMATION_14", enumDescription: "Zusatzinformation 14" },
    { enumIdentifier: "ZUSATZINFORMATION_15", enumDescription: "Zusatzinformation 15" },
    { enumIdentifier: "ZUSATZINFORMATION_16", enumDescription: "Zusatzinformation 16" },
    { enumIdentifier: "ZUSATZINFORMATION_17", enumDescription: "Zusatzinformation 17" },
    { enumIdentifier: "ZUSATZINFORMATION_18", enumDescription: "Zusatzinformation 18" },
    { enumIdentifier: "ZUSATZINFORMATION_19", enumDescription: "Zusatzinformation 19" },
    { enumIdentifier: "ZUSATZINFORMATION_20", enumDescription: "Zusatzinformation 20" },
    { enumIdentifier: "AUFTRAGSNUMMER", enumDescription: "Auftragnummer" },
    { enumIdentifier: "ABRECHNUNGSREFERENZ", enumDescription: "Abrechnungsreferenz" },
];
